import React from "react";

const GDPR = () => {
  return <section className="py-5 fw-semibold">GDPR Compliance...</section>;
};

export default GDPR;
